<template>
  <div class="login-index">
    <div class="no-app">

      <img src="@/assets/img/501.png" alt="">
      <h1 style="text-align: center">{{$t('code501')}}</h1>
    </div>
  </div>

</template>
<style lang='scss' scoped>
  .login-index {
    height: 100%;
    min-width: 1500px;
    .no-app {
      display: inline-block;
      position: relative;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      img {
        margin-left: 120px;
      }
      .no-title {
        text-align: center;
        margin-top: 50px;
        font-size: 16px;
      }
    }
  }

</style>
<script>
  export default {
    data() {
      return {};
    },
    created() {
      this.lang = this.$i18n.locale

    },
  };
</script>
